export type HeaderNavigation = {
  atTop: boolean;
  isActiveService(url: string, segment: string): boolean;
};

function headerNavigation(): HeaderNavigation {
  return {
    atTop: true,
    isActiveService(url, segment) {
      switch (url) {
        case '/erhverv':
          return segment === 'erhverv';
        case '/nyt-sundt':
          return segment === 'nyt-sundt';
        case '/for-behandlere':
          return segment === 'for-behandlere';
        case '/':
          if (
            segment === 'erhverv' ||
            segment === 'nyt-sundt' ||
            segment === 'for-behandlere'
          )
            return false;

          return true;
        default:
          return false;
      }
    },
  };
}

window.headerNavigation = headerNavigation;
